/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Logger — referans-parite (lib/Logger.tsx). Seviyeli, isimli, child-logger'lı.
 * Dev'de hepsi, prod'da warn+ (gürültü azalır). Sentry'ye köprü kolay (error()).
 *
 * Kullanım:  const log = logger.child("Gateway"); log.warn("...", err);
 */
export const LogLevel = { DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3 } as const;
export type LogLevelValue = (typeof LogLevel)[keyof typeof LogLevel];

const IS_DEV = process.env.NODE_ENV !== "production";

export class Logger {
  constructor(
    private readonly name: string,
    private readonly minLevel: LogLevelValue = IS_DEV ? LogLevel.DEBUG : LogLevel.WARN
  ) {}

  /** Alt-logger (örn. logger.child("Gateway") → "[TEBHOS:Gateway]"). */
  child(suffix: string): Logger {
    return new Logger(`${this.name}:${suffix}`, this.minLevel);
  }

  private emit(level: LogLevelValue, method: "debug" | "info" | "warn" | "error", args: any[]): void {
    if (level < this.minLevel || typeof console === "undefined") return;
    // eslint-disable-next-line no-console
    (console[method] as any)(`[${this.name}]`, ...args);
  }

  debug(...args: any[]): void { this.emit(LogLevel.DEBUG, "debug", args); }
  info(...args: any[]): void { this.emit(LogLevel.INFO, "info", args); }
  warn(...args: any[]): void { this.emit(LogLevel.WARN, "warn", args); }
  error(...args: any[]): void { this.emit(LogLevel.ERROR, "error", args); }
}

/** Kök logger — child() ile alt-logger türet. */
export const logger = new Logger("TEBHOS");
